import React from 'react';
import { Calendar } from "assets/icons";
import UseContext from "hooks/useContext";
import SidebarUnitMobile from "components/sidebar/components/SidebarUnitMobile";

const TimeSheetML = ({ pathname }) => {
    const { language } = UseContext();
    const isActive = pathname.includes("timeSheet");
    
    return (
        <SidebarUnitMobile routeName={"Relevé d'heures"} routeSidebar={"/timeSheet/toBeCompleted"}>
            <div className="flex flex-col justify-center items-center">
                <span className='shrink-0'>
                    <Calendar wh={28} color={isActive ? '#FF9600' : '#6B7280'} />
                </span>
                <span
                    className={`text-[9px] font-medium whitespace-normal text-center ${
                        isActive && "!text-[#FF9600]"
                    }`}
                >
                    {language.getValue('sidebar.timeSheet', "Relevé d'heures")}
                </span>
            </div>
        </SidebarUnitMobile>
    );
};

export default TimeSheetML;
